import { deployContracts } from "./deploy/deployContracts"
import { fundAccounts } from "./deploy/fundAccounts"
import { type Bundler, toBundler } from "./toBundler"
import { type MeeNode, toMeeNode } from "./toMeeNode"
import { type Network, toNetwork } from "./toNetwork"
import { type Clients, type Url, toClients } from "./utils"

export type ToEcosystemParameters = {
  chainLength?: number
  forkUrl?: string
  withMee?: boolean
}

export type Infra = { network: Network; bundler: Bundler }

export type Ecosystem = {
  meeNode?: MeeNode
  infras: Infra[]
  clients: Clients[]
}

export const toEcosystem = async (
  parameters?: ToEcosystemParameters
): Promise<Ecosystem> => {
  const { chainLength = 1, forkUrl, withMee = false } = parameters ?? {}
  const infras = await Promise.all(
    Array.from({ length: chainLength }, async () => {
      const network = await toNetwork({ forkUrl })
      await fundAccounts(network)
      await deployContracts(network)
      const bundler = await toBundler(network)
      return { network, bundler }
    })
  )

  const clients = await Promise.all(
    infras.map(async (infra) =>
      toClients({
        rpcUrl: infra.network.rpcUrl,
        chain: infra.network.chain
      })
    )
  )

  const result: Ecosystem = {
    meeNode: withMee ? await toMeeNode({ infras }) : undefined,
    infras,
    clients
  }

  return result
}
